// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt-module-style-normalize img,
.mt-module-style-normalize video {
  max-width: 100%;
  height: auto;
}


.mt-module-style-normalize img,
.mt-module-style-normalize svg,
.mt-module-style-normalize video,
.mt-module-style-normalize canvas,
.mt-module-style-normalize audio,
.mt-module-style-normalize iframe,
.mt-module-style-normalize embed,
.mt-module-style-normalize object {
  display: inline-block;
  vertical-align: middle;
}

.mt-module-style-normalize .text-secondary-foreground {
  background-color: hsl(187 65% 92%) !important;
}

.mt-module-style-normalize .bg-secondary {
  background-color: hsl(187 65% 92%) !important;
}

.mt-module-style-normalize .p-4 {
  padding: 1rem !important;
}

.mt-module-style-normalize .group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100,
.mt-module-style-normalize .group:hover .group-hover\\:opacity-100 {
  opacity: 1 !important;
}

body>*:not(.mt-module-style-normalize) img,
body>*:not(.mt-module-style-normalize) svg,
body>*:not(.mt-module-style-normalize) video {
  display: initial;
}

body>*:not(.mt-module-style-normalize) .collapse {
  visibility: unset;
}

.mt-module-style-normalize {
  contain: style;
}

@media (min-width: 1280px) {
  .mt-module-style-normalize .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .mt-module-style-normalize .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .mt-module-style-normalize .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .mt-module-style-normalize .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }

  .mt-module-style-normalize .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .booking-view-top-card-view .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }

  .mt-module-style-normalize .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }
}

.mt-module-style-normalize .collapse {
  visibility: collapse;
}

.booking-calendar-view .booking-Calendar-container.flex.w-full {
  padding-left: 30px !important;
}

.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(198 88% 95%) !important;
}

.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(198 88% 28%) !important;
}

.rdp.p-3.pointer-events-auto.rdp-multiple_months .bg-primary {
  background-color: hsl(198 88% 44%) !important;
}

.mt-dialog-style-normalize .bg-secondary {
  background-color: hsl(210 40% 96.1%);
}

.mt-dialog-style-normalize .text-secondary-foreground {
  color: hsl(215 25% 15%);
}

@media (min-width: 768px) {
  .mt-dialog-style-normalize .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .mt-module-style-normalize .md\\:flex-row {
    flex-direction: row;
  }
}

@media (min-width: 640px) {
  .mt-dialog-style-normalize .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.view-dialog-style-normalize {
  z-index: 999 !important;
}

.mt-dialog-style-normalize .pl-9 {
  padding-left: 2.25rem !important;
}

.mt-dialog-style-normalize {
  z-index: 999 !important;
}

.mt-module-style-normalize {


  .\\[\\&\\>div\\]\\:bg-emerald-500>div {
    --tw-bg-opacity: 1;
    background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1)) !important;
  }

  font-family: ui-sans-serif,
  system-ui,
  -apple-system,
  BlinkMacSystemFont,
  Segoe UI,
  Roboto,
  Helvetica Neue,
  Arial,
  Noto Sans,
  sans-serif,
  Apple Color Emoji,
  Segoe UI Emoji,
  Segoe UI Symbol,
  Noto Color emoji !important;

  .funnel-scrollbar {
    scrollbar-width: thin;
  }

  .data-\\[state\\=on\\]\\:text-accent-foreground[data-state=on] {
    background-color: #007bff !important;
    color: #fff !important;
  }

  .funnel-card {
    padding: 0.75rem !important;
    border-radius: 0.75rem !important;
  }

  .funnel-card-user-info {
    p {
      margin-bottom: 0 !important;
    }
  }

  .bg-primary\\/10 {
    background-color: #3c83f61a;
  }

  p {
    margin-bottom: 0 !important;
  }

  .p-3 {
    padding: 0.75rem !important;
  }

  .py-4 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .pb-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .mb-3 {
    margin-bottom: 0.75rem !important;
  }

  .mt-3 {
    margin-top: 0.75rem !important;
  }

  .ml-3 {
    margin-left: 0.75rem !important;
  }

  .mr-3 {
    margin-right: 0.75rem !important;
  }

  .primary-gradient {
    background: linear-gradient(135deg, #3b82f6, #60a5fa) !important;
  }
}

.font-medium {
  font-weight: 500 !important;
  /* color: #0f1729 !important; */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}

.rightside-panel,
.prospect_module {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji !important;

  .bg-secondary {
    background-color: #f1f5f9 !important;
    border: transparent !important;
    font-weight: 500 !important;
    /* color: #0f1729 !important; */
  }

  .px-5 {
    padding-left: 1.5rem !important;
  }

  .space-y-2 {
    /* margin-top: 1rem !important;
    line-height: 0 !important; */

    input,
    button {
      margin-top: 0rem !important;
    }
  }

  .create-activity-dialog {
    right: 15rem !important;
    left: 15rem !important;
  }

  .focus-visible\\:ring-ring:focus-visible {
    --tw-ring-color: hsl(217 91% 60%) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
  }

  kbd {
    color: hsl(var(--muted-foreground));
  }

  div[role="tabpanel"] {
    .focus\\:border-primary\\/50:focus {
      border-color: hsl(217 91% 60% / .5);
    }
  }

  .hover\\:bg-primary\\/80:hover {
    background-color: hsl(217 91% 60% / 0.8);
  }

  div[role="tablist"] {
    .rounded-sm {
      border-radius: calc(var(--radius) - 4px) !important;
    }
  }

  .grid {
    .rounded-lg {
      border-radius: var(--radius) !important;
    }
  }

}

.rounded-lg {
  border-radius: var(--radius) !important;
}

@media (min-width: 640px) {
  .sm\\:text-left {
    text-align: left !important;
  }

  .sm\\:flex-row {
    .mt-2 {
      margin-top: 0 !important;
    }
  }
}

.bg-primary\\/20 {
  background-color: hsl(211 100% 50% / 0.2) !important;
}

/* Ring utilities for hover and focus states */
.ring-primary\\/30 {
  --tw-ring-color: hsl(217 91% 60% / 0.3) !important;
  --tw-ring-shadow: inset 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
  border-radius: 0.75rem !important;
}

/* Focus-visible ring styling */
.focus-visible\\:ring-primary\\/30:focus-visible {
  --tw-ring-color: hsl(217 91% 60%) !important;
  --tw-ring-shadow: inset 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

/* Hide scrollbar but allow scroll */
.hide-scrollbar {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.prospect_module {
  max-height: 85vh;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji !important;
  background: #fff;

  .text-xl {
    font-size: 15px;
  }

  h4 {
    font-size: 14px;
  }

  .p-5 {
    padding: 1rem !important;
  }
}

#radix-\\:r9\\: {

  .pb-4,
  .py-4 {
    padding-bottom: 0rem !important;
  }

  h4 {
    font-size: 14px !important;
  }

  .p-4,
  .mb-4,
  .my-4 {
    padding: .5rem !important;
  }
}

.recharts-area-area {
  fill: hsl(217 90% 60% / 2) !important;
  fill-opacity: 0.2;
}

.recharts-area-curve {
  stroke: hsl(217 90% 60%) !important;
  fill: none;
  fill-opacity: 0.6;
}

.property_size_distribution_block {
  .recharts-rectangle:not(.recharts-tooltip-cursor):not(.recharts-bar-rectangle) {
    fill: hsl(217 90% 60%) !important;
  }
}

.recharts-tooltip-cursor {
  fill: rgba(128, 128, 128, 0.15) !important;
}

.field_visibility_sec {
  .data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
    color: #007bff !important;
  }

  .items-center {
    label {
      display: inline-block !important;
      margin-bottom: 0 !important;
    }

    .text-xs {
      font-size: .75rem !important;
      line-height: 0rem !important;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/Utility/Public/css/mt-modules-scoped.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,YAAY;AACd;;;AAGA;;;;;;;;EAQE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE;IACE,kBAAkB;IAClB,sEAAsE;EACxE;;EAEA;;;;;;;;;;;;;6BAa2B;;EAE3B;IACE,qBAAqB;EACvB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gEAAgE;EAClE;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,yNAAyN;AAC3N;;AAEA;;;;;;;EAOE,SAAS;AACX;;AAEA;;EAEE,yNAAyN;;EAEzN;IACE,oCAAoC;IACpC,8BAA8B;IAC9B,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE;gCAC4B;;IAE5B;;MAEE,2BAA2B;IAC7B;EACF;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,4CAA4C;IAC5C,uGAAuG;EACzG;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE;MACE,mCAAmC;IACrC;EACF;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE;MACE,mDAAmD;IACrD;EACF;;EAEA;IACE;MACE,uCAAuC;IACzC;EACF;;AAEF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA,8CAA8C;AAC9C;EACE,kDAAkD;EAClD,qGAAqG;EACrG,uGAAuG;EACvG,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,4CAA4C;EAC5C,qGAAqG;EACrG,uGAAuG;AACzG;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yNAAyN;EACzN,gBAAgB;;EAEhB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;IAEE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,gCAAgC;MAChC,2BAA2B;IAC7B;;IAEA;MACE,4BAA4B;MAC5B,4BAA4B;IAC9B;EACF;AACF","sourcesContent":[".mt-module-style-normalize img,\n.mt-module-style-normalize video {\n  max-width: 100%;\n  height: auto;\n}\n\n\n.mt-module-style-normalize img,\n.mt-module-style-normalize svg,\n.mt-module-style-normalize video,\n.mt-module-style-normalize canvas,\n.mt-module-style-normalize audio,\n.mt-module-style-normalize iframe,\n.mt-module-style-normalize embed,\n.mt-module-style-normalize object {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.mt-module-style-normalize .text-secondary-foreground {\n  background-color: hsl(187 65% 92%) !important;\n}\n\n.mt-module-style-normalize .bg-secondary {\n  background-color: hsl(187 65% 92%) !important;\n}\n\n.mt-module-style-normalize .p-4 {\n  padding: 1rem !important;\n}\n\n.mt-module-style-normalize .group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100,\n.mt-module-style-normalize .group:hover .group-hover\\:opacity-100 {\n  opacity: 1 !important;\n}\n\nbody>*:not(.mt-module-style-normalize) img,\nbody>*:not(.mt-module-style-normalize) svg,\nbody>*:not(.mt-module-style-normalize) video {\n  display: initial;\n}\n\nbody>*:not(.mt-module-style-normalize) .collapse {\n  visibility: unset;\n}\n\n.mt-module-style-normalize {\n  contain: style;\n}\n\n@media (min-width: 1280px) {\n  .mt-module-style-normalize .xl\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .mt-module-style-normalize .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .mt-module-style-normalize .lg\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;\n  }\n\n  .mt-module-style-normalize .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;\n  }\n\n  .mt-module-style-normalize .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n  }\n\n  .booking-view-top-card-view .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;\n  }\n\n  .mt-module-style-normalize .xl\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;\n  }\n}\n\n.mt-module-style-normalize .collapse {\n  visibility: collapse;\n}\n\n.booking-calendar-view .booking-Calendar-container.flex.w-full {\n  padding-left: 30px !important;\n}\n\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:bg-accent[aria-selected=\"true\"] {\n  background-color: hsl(198 88% 95%) !important;\n}\n\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:text-accent-foreground[aria-selected=\"true\"] {\n  color: hsl(198 88% 28%) !important;\n}\n\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .bg-primary {\n  background-color: hsl(198 88% 44%) !important;\n}\n\n.mt-dialog-style-normalize .bg-secondary {\n  background-color: hsl(210 40% 96.1%);\n}\n\n.mt-dialog-style-normalize .text-secondary-foreground {\n  color: hsl(215 25% 15%);\n}\n\n@media (min-width: 768px) {\n  .mt-dialog-style-normalize .md\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .mt-module-style-normalize .md\\:flex-row {\n    flex-direction: row;\n  }\n}\n\n@media (min-width: 640px) {\n  .mt-dialog-style-normalize .sm\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.view-dialog-style-normalize {\n  z-index: 999 !important;\n}\n\n.mt-dialog-style-normalize .pl-9 {\n  padding-left: 2.25rem !important;\n}\n\n.mt-dialog-style-normalize {\n  z-index: 999 !important;\n}\n\n.mt-module-style-normalize {\n\n\n  .\\[\\&\\>div\\]\\:bg-emerald-500>div {\n    --tw-bg-opacity: 1;\n    background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1)) !important;\n  }\n\n  font-family: ui-sans-serif,\n  system-ui,\n  -apple-system,\n  BlinkMacSystemFont,\n  Segoe UI,\n  Roboto,\n  Helvetica Neue,\n  Arial,\n  Noto Sans,\n  sans-serif,\n  Apple Color Emoji,\n  Segoe UI Emoji,\n  Segoe UI Symbol,\n  Noto Color emoji !important;\n\n  .funnel-scrollbar {\n    scrollbar-width: thin;\n  }\n\n  .data-\\[state\\=on\\]\\:text-accent-foreground[data-state=on] {\n    background-color: #007bff !important;\n    color: #fff !important;\n  }\n\n  .funnel-card {\n    padding: 0.75rem !important;\n    border-radius: 0.75rem !important;\n  }\n\n  .funnel-card-user-info {\n    p {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  .bg-primary\\/10 {\n    background-color: #3c83f61a;\n  }\n\n  p {\n    margin-bottom: 0 !important;\n  }\n\n  .p-3 {\n    padding: 0.75rem !important;\n  }\n\n  .py-4 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .mb-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mt-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .ml-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .mr-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .primary-gradient {\n    background: linear-gradient(135deg, #3b82f6, #60a5fa) !important;\n  }\n}\n\n.font-medium {\n  font-weight: 500 !important;\n  /* color: #0f1729 !important; */\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0;\n}\n\n.rightside-panel,\n.prospect_module {\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji !important;\n\n  .bg-secondary {\n    background-color: #f1f5f9 !important;\n    border: transparent !important;\n    font-weight: 500 !important;\n    /* color: #0f1729 !important; */\n  }\n\n  .px-5 {\n    padding-left: 1.5rem !important;\n  }\n\n  .space-y-2 {\n    /* margin-top: 1rem !important;\n    line-height: 0 !important; */\n\n    input,\n    button {\n      margin-top: 0rem !important;\n    }\n  }\n\n  .create-activity-dialog {\n    right: 15rem !important;\n    left: 15rem !important;\n  }\n\n  .focus-visible\\:ring-ring:focus-visible {\n    --tw-ring-color: hsl(217 91% 60%) !important;\n    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n  }\n\n  kbd {\n    color: hsl(var(--muted-foreground));\n  }\n\n  div[role=\"tabpanel\"] {\n    .focus\\:border-primary\\/50:focus {\n      border-color: hsl(217 91% 60% / .5);\n    }\n  }\n\n  .hover\\:bg-primary\\/80:hover {\n    background-color: hsl(217 91% 60% / 0.8);\n  }\n\n  div[role=\"tablist\"] {\n    .rounded-sm {\n      border-radius: calc(var(--radius) - 4px) !important;\n    }\n  }\n\n  .grid {\n    .rounded-lg {\n      border-radius: var(--radius) !important;\n    }\n  }\n\n}\n\n.rounded-lg {\n  border-radius: var(--radius) !important;\n}\n\n@media (min-width: 640px) {\n  .sm\\:text-left {\n    text-align: left !important;\n  }\n\n  .sm\\:flex-row {\n    .mt-2 {\n      margin-top: 0 !important;\n    }\n  }\n}\n\n.bg-primary\\/20 {\n  background-color: hsl(211 100% 50% / 0.2) !important;\n}\n\n/* Ring utilities for hover and focus states */\n.ring-primary\\/30 {\n  --tw-ring-color: hsl(217 91% 60% / 0.3) !important;\n  --tw-ring-shadow: inset 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n  border-radius: 0.75rem !important;\n}\n\n/* Focus-visible ring styling */\n.focus-visible\\:ring-primary\\/30:focus-visible {\n  --tw-ring-color: hsl(217 91% 60%) !important;\n  --tw-ring-shadow: inset 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;\n}\n\n/* Hide scrollbar but allow scroll */\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, Opera */\n}\n\n.prospect_module {\n  max-height: 85vh;\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji !important;\n  background: #fff;\n\n  .text-xl {\n    font-size: 15px;\n  }\n\n  h4 {\n    font-size: 14px;\n  }\n\n  .p-5 {\n    padding: 1rem !important;\n  }\n}\n\n#radix-\\:r9\\: {\n\n  .pb-4,\n  .py-4 {\n    padding-bottom: 0rem !important;\n  }\n\n  h4 {\n    font-size: 14px !important;\n  }\n\n  .p-4,\n  .mb-4,\n  .my-4 {\n    padding: .5rem !important;\n  }\n}\n\n.recharts-area-area {\n  fill: hsl(217 90% 60% / 2) !important;\n  fill-opacity: 0.2;\n}\n\n.recharts-area-curve {\n  stroke: hsl(217 90% 60%) !important;\n  fill: none;\n  fill-opacity: 0.6;\n}\n\n.property_size_distribution_block {\n  .recharts-rectangle:not(.recharts-tooltip-cursor):not(.recharts-bar-rectangle) {\n    fill: hsl(217 90% 60%) !important;\n  }\n}\n\n.recharts-tooltip-cursor {\n  fill: rgba(128, 128, 128, 0.15) !important;\n}\n\n.field_visibility_sec {\n  .data-\\[state\\=checked\\]\\:text-primary-foreground[data-state=\"checked\"] {\n    color: #007bff !important;\n  }\n\n  .items-center {\n    label {\n      display: inline-block !important;\n      margin-bottom: 0 !important;\n    }\n\n    .text-xs {\n      font-size: .75rem !important;\n      line-height: 0rem !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
